import React from 'react';

export const TOPIC_CARD_ICON_1 = 'rgb(var(--color-topic-card-icon-1))';
export const TOPIC_CARD_ICON_2 = 'rgb(var(--color-topic-card-icon-2))';

export const TopicCardDivider: React.FC = () => (
  <div className="border-topic-card-divider h-0 w-28 shrink-0 border-t-2 sm:w-44" aria-hidden />
);

interface TopicCardTitleProps {
  title: string;
  className?: string;
}

export const TopicCardTitle: React.FC<TopicCardTitleProps> = ({ title, className = '' }) => (
  <p
    className={`font-albert-sans mt-2 max-w-[120px] text-center text-xs font-medium leading-snug text-black sm:mt-3 sm:max-w-[200px] sm:text-lg ${className}`}
  >
    {title.split('\n').map((line, i) => (
      <React.Fragment key={i}>
        {i > 0 && <br />}
        {line}
      </React.Fragment>
    ))}
  </p>
);
